import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { EmailTemplate } from 'src/app/models/EmailTemplateModel';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { PlatformApiService, ResultFilter, Results } from 'src/app/services/platform-api.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'cw-ci-email-template-list',
  templateUrl: './email-template-list.component.html',
  styleUrls: ['./email-template-list.component.scss']
})
export class EmailTemplateListComponent implements OnInit {
  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(DataTableComponent, { static: true }) emailDataTable: DataTableComponent;
  emailList: Results;

  constructor(private _platformApi: PlatformApiService, public dialog: MatDialog) { }

  ngOnInit() {

  }

  isSelectable(item: EmailTemplate) {
    return true;
  }

  addEmailTemplate(event?) {
    this.stateChange.emit({ state: 'CREATE' });
  }

  editEmailTemplate(item: EmailTemplate) {
    this.stateChange.emit({ state: 'EDIT', item });
  }

  loadEmailTemplates(filter = new ResultFilter()) {
    this.emailDataTable.showProcessing();
    const listObservable = this._platformApi.getEmailTemplates(filter);
    listObservable.subscribe(results => {
      this.emailList = results;
    })
  }
}
